import styled from 'styled-components';

import { Link } from 'react-router-dom';

export const Container = styled(Link)`
  position: relative;
  user-select: none;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  color: ${({ theme }) => theme.colors.white} !important;
  background: ${({ theme }) => theme.cards.primary};
  border-radius: ${({ theme }) => theme.radius.primary};
  border: 1px solid ${({ theme }) => theme.cards.border};	
  padding: 1rem;
  text-decoration: none;
  gap: 1rem;
  transition: all .2s ease-in-out;
  
  &:hover {
    
    > aside {
      scale: 1.05;
      
      &:before {
        scale: 1.1;
        background: #fe157e;
      }

      > img {
      }
    }
  }
  
  > aside {
    position: relative;
    display: flex;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all .2s ease-in-out;
    
    &:before {
      content: '';
      background: ${({ theme }) => theme.cards.secondary};
      border-radius: 50%;
      width: 7rem;
      height: 7rem;
      background: ${props => props.theme.cards.tertiary};
      position: absolute;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: all .4s ease-in-out;
      
      @keyframes pulse {
        0% {
          transform: scale(0.9);
        }
        50% {
          transform: scale(1);
        }
        100% {
          transform: scale(0.9);
        }
      }
    }
    
    > img {
      width: 8rem;
      position: relative;
    } 
  }
  
  > main {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 1rem;

    > h3 {
      font-size: 12px;
      font-weight: 600;
      display: flex;
      align-items: center;
      text-align: center;
    }

    > p {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      font-size: 10px;
      font-weight: 400;
      margin-bottom: 0.5rem;
      background: ${({ theme }) => theme.cards.tertiary};
      padding: 0.25rem 0.5rem;
      border-radius: ${({ theme }) => theme.radius.primary};
    }
  }
  
`;